import React from "react";

import SearchList from "./SearchList";
import NavigationBar from "../NavigationBar";

const SearchResults = (zip) =>  {

    return (
        <div className="row mt-2">
            <NavigationBar/>
            <SearchList/>
        </div>
    );
};

export default SearchResults;